import React from 'react';
import { Link } from 'react-router-dom';
import { Info, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const FAQSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked <span className="text-alden-green">Questions</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Common questions about mineral water plant setup, investment, and licensing.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          {[
            {
              id: 'faq-cost',
              q: 'What is the cost of setting up a mineral water plant?',
              a: 'The cost varies based on capacity. A 30 BPM plant starts from ₹8-12 lakhs, while a 200 BPM plant costs ₹80 lakhs - 1.2 crores. We provide customized quotations based on your requirements.'
            },
            {
              id: 'faq-licenses',
              q: 'What licenses are required to start a mineral water business?',
              a: 'You need FSSAI license, BIS certification (IS 14543), Pollution Control Board clearance, Trade License, and GST registration. We provide complete compliance support.'
            },
            {
              id: 'faq-timeline',
              q: 'How long does installation take?',
              a: 'Typically 3-6 months from order confirmation including manufacturing, delivery, installation, testing, and commissioning. Timeline depends on plant capacity and complexity.'
            },
            {
              id: 'faq-support',
              q: 'Do you provide after-sales support?',
              a: 'Yes, we provide comprehensive 12-month warranty, operator training, spare parts supply, AMC options, and 24/7 technical support across India.'
            }
          ].map((faq) => (
            <Card key={faq.id} className="border-2 border-alden-green/20 hover:border-alden-green transition-all">
              <CardContent className="p-8">
                <h3 className="font-bold text-lg text-gray-900 mb-3 flex items-start gap-2">
                  <Info className="w-5 h-5 text-alden-green flex-shrink-0 mt-1" />
                  {faq.q}
                </h3>
                <p className="text-gray-700 leading-relaxed pl-7">{faq.a}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/faq">
            <Button className="bg-alden-green hover:bg-alden-green-light text-white py-6 px-10 text-lg font-semibold">
              View All FAQs
              <ArrowRight className="ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
